module.exports = require("prismjs/components/prism-http.js");